
export class SitnGoVO {
    public id: number = 0;
    public name: string;
    public buyIn: number = 0;
    public fee: number = 0;
    public status: number = 0;
    public currentPlayers: number = 0;
    public pot: number = 0;
    // 0: grün, 1: gelb ,2: rot
    public xpEarnStatus: number = 0;
}
